import { theme } from 'styles/theme/hav-theme'
import {
  EDI,
  HC,
  ND,
  Trash,
  Send,
  HomeOutlined,
  HomeRounded,
  Support,
  Notification,
  NotificationOff,
  Sandal,
  Money,
  TrendingUp,
  ChevronDown,
  ChevronUp,
  ChevronRight,
  ChevronLeft,
  Close,
  PhoneInTalk,
  Visibility,
  VisibilityOff,
  ExitToApp,
  TaskAlt,
  Error,
  Info,
  Report,
  Duplicate,
  Menu,
  Filter,
  Search,
  SearchOff,
  ArrowFoward,
  Profile,
  Edit,
  Calendar,
  Save,
  Empty,
  Clock,
  Email,
  Smartphone,
  PostAdd,
  Upload,
  Download,
  Ellipsis,
  Percent,
  PostOff,
  PostOn,
  Note,
  Track,
  PapperClip,
  Cancel,
  Undo,
  ClearAll,
  Sync,
  Sort,
  DateTransfer,
  RequestQuote,
  ExternalLink,
  Box,
  Expand,
  GiveBack,
  File,
  Swap,
  History,
  Megaphone,
  Archive,
  List,
  Share,
  Palette,
  Consult,
  Less,
  More,
  SyncProplem,
  Tag,
  Factory,
  MissingPiece,
  AltRoute,
  Batch,
  BarChart,
  Budget,
  Sticky,
  Loading,
  Star,
  Placeholder,
  Loader,
  CalendarClock
} from './AllIcons'

export const icons = {
  edi: EDI,
  hc: HC,
  nd: ND,
  trash: Trash,
  send: Send,
  'home-outlined': HomeOutlined,
  'home-rounded': HomeRounded,
  notification: Notification,
  'notification-off': NotificationOff,
  'chevron-down': ChevronDown,
  'chevron-up': ChevronUp,
  'chevron-right': ChevronRight,
  'chevron-left': ChevronLeft,
  close: Close,
  'phone-in-talk': PhoneInTalk,
  visibility: Visibility,
  'visibility-off': VisibilityOff,
  'exit-to-app': ExitToApp,
  'task-alt': TaskAlt,
  error: Error,
  info: Info,
  report: Report,
  duplicate: Duplicate,
  menu: Menu,
  filter: Filter,
  search: Search,
  'search-off': SearchOff,
  'arrow-forward': ArrowFoward,
  profile: Profile,
  edit: Edit,
  calendar: Calendar,
  save: Save,
  empty: Empty,
  clock: Clock,
  email: Email,
  smartphone: Smartphone,
  'post-add': PostAdd,
  upload: Upload,
  download: Download,
  ellipsis: Ellipsis,
  percent: Percent,
  'post-off': PostOff,
  'post-on': PostOn,
  note: Note,
  track: Track,
  'paper-clip': PapperClip,
  cancel: Cancel,
  undo: Undo,
  'clear-all': ClearAll,
  sync: Sync,
  sort: Sort,
  'date-transfer': DateTransfer,
  'request-quote': RequestQuote,
  'external-link': ExternalLink,
  box: Box,
  expand: Expand,
  'give-back': GiveBack,
  file: File,
  swap: Swap,
  history: History,
  sandal: Sandal,
  money: Money,
  'trending-up': TrendingUp,
  megaphone: Megaphone,
  archive: Archive,
  list: List,
  share: Share,
  palette: Palette,
  consult: Consult,
  tag: Tag,
  less: Less,
  more: More,
  'sync-problem': SyncProplem,
  support: Support,
  factory: Factory,
  'missing-piece': MissingPiece,
  'alt-route': AltRoute,
  batch: Batch,
  'bar-chart': BarChart,
  budget: Budget,
  sticky: Sticky,
  loading: Loading,
  star: Star,
  placeholder: Placeholder,
  loader: Loader,
  'calendar-clock': CalendarClock
}

export const ICON_DEFAULT_SIZE = '50'
export const ICON_DEFAULT_VIEWBOX = '0 0 50 50'
export const ICON_DEFAULT_COLOR = theme.colors.neutral[90]
export const ICON_DEFAULT_DISABLED_COLOR = theme.colors.neutral.lighthover
export const ICON_DEFAULT_FILL = 'none'
export const ICON_DEFAULT_WIDTH = ICON_DEFAULT_SIZE
export const ICON_DEFAULT_HEIGHT = ICON_DEFAULT_SIZE

export type IconProps = {
  icon: keyof typeof icons
  color?: string
  fill?: string
  width?: string
  height?: string
  size?: string
  viewBox?: string
}

export const Icon = ({ icon, color, fill, size, viewBox, ...props }: IconProps) => {
  const IconComponent = icons[icon]

  return (
    <IconComponent
      color={color}
      fill={fill}
      viewBox={viewBox}
      {...(size ? { width: size, height: size } : {})}
      {...props}
    />
  )
}
